import * as React from 'react';
import classnames from 'classnames';
import { SvgIcon, Heading, Col, Row, Image, ImageOverlay, StudyPlanButton } from 'seduo-ui';
const Tile = ({ videoRef, href, title, lector, large, imageSrc, video, onVideoAction, overlay, studyPlan, isMobile, className, }) => {
    const { muted, pause, src, type, loop, autoplay } = video || {};
    const triggerMuteAction = () => {
        if (muted) {
            onVideoAction('unmute');
        }
        else {
            onVideoAction('mute');
        }
    };
    const triggerPauseAction = () => {
        if (!src || isMobile) {
            return;
        }
        if (pause) {
            onVideoAction('play');
        }
        else {
            onVideoAction('pause');
        }
    };
    return (<div onMouseEnter={triggerPauseAction} onMouseLeave={triggerPauseAction} className={classnames('tile', { 'tile--large': large }, className)}>
            <ImageOverlay {...overlay}>
                <Image className={classnames('tile__img', { 'tile__img--large': large }, { 'tile__img--invisible-on-hover': src })} src={imageSrc} alt="Title"/>
            </ImageOverlay>
            {src && videoRef && !isMobile && (<video ref={videoRef} className="tile__video" preload="metadata" autoPlay={autoplay} muted={muted} loop={loop} disablePictureInPicture={true}>
                    <source src={src} type={type}/>
                </video>)}
            <a href={href}>
                <div className="tile__details">
                    <Row className="align-self-end m-0 w-100 no-gutters">
                        <Col>
                            {lector && (<span className="fw-medium text-white text-truncate-multiline text-truncate-multiline-1">
                                    {lector}
                                </span>)}
                            {title && (<Heading level={3} className="fw-bold text-white">
                                    <span className="text-truncate-multiline text-truncate-multiline-2">{title}</span>
                                </Heading>)}
                        </Col>
                        <Col sm={2}/>
                    </Row>
                </div>
            </a>
            {video && !isMobile && (<div className="tile__overlay tile__overlay--bottom-right">
                    <button onClick={triggerMuteAction} className="btn tile__button tile__button--volume" type="button">
                        <SvgIcon kind={muted ? 'VolumeOff' : 'VolumeOn'} className="icon-white"/>
                    </button>
                </div>)}
            {studyPlan && (<div className="tile__overlay tile__overlay--top-right">
                    <StudyPlanButton {...studyPlan} className={classnames({ tile__button: !isMobile })} large/>
                </div>)}
        </div>);
};
Tile.defaultProps = {
    large: false,
    href: '#',
    onVideoAction: null,
    isMobile: false,
};
export default Tile;
